import { API_CALLS } from "@/services/apis/index.js";

export default {
  getAllSupplyOrders() {
    return new Promise((resolve, reject) => {
      API_CALLS.getAllSupplyOrdersAPI()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addSupplyOrder(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.addSupplyOrderAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  editSupplyOrder(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.editSupplyOrderAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  changeSOState(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.changeSOStateAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteSOFile(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.deleteSOFileAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  downloadSupplyFile(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.downloadSupplyFileAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
